import { withTranslations } from '@/utils/Language';
import resourceCardEn from '@/assets/i18n/resourceCard/en.json';
import distanceEn from '@/assets/i18n/distance/en.json';
import propertiesEn from '@/assets/i18n/properties/en.json';
import tagsEn from '@/assets/i18n/tags/en.json';
import uiEn from '@/assets/i18n/ui/en.json';
import languagesEn from '@/assets/i18n/languages/default.json';
import languagesTranslatedEn from '@/assets/i18n/languages_translated/en.json';

const enDefault = { ...resourceCardEn, ...distanceEn, ...propertiesEn, ...tagsEn, ...uiEn, ...languagesEn, ...languagesTranslatedEn };

export default withTranslations(
  (lang) =>
    Promise.all([
      import(`@/assets/i18n/resourceCard/${lang}.json`),
      import(`@/assets/i18n/distance/${lang}.json`),
      import(`@/assets/i18n/properties/${lang}.json`),
      import(`@/assets/i18n/tags/${lang}.json`),
      import(`@/assets/i18n/ui/${lang}.json`),
      import('@/assets/i18n/languages/default.json'),
      import(`@/assets/i18n/languages_translated/${lang}.json`)
    ]).then(([resourceCard, distance, properties, tags, ui, languages, languagesTranslated]) => ({
      ...resourceCard.default,
      ...distance.default,
      ...properties.default,
      ...tags.default,
      ...ui.default,
      ...languages.default,
      ...languagesTranslated.default
    })),
  enDefault
);
